import { api } from "@/state/services";

// Lista das páginas ativas de "Como Funciona" (GET pages), guardada no localStorage
const STORAGE_KEY = "how_it_works_pages";

// Promessa da consulta desta entrada no app: a API é chamada uma única vez por carregamento
let request = null;

// Lê a lista salva no localStorage (vazia se não existir ou estiver inválida)
export function getCachedPages() {
  try {
    const list = JSON.parse(localStorage.getItem(STORAGE_KEY));
    return Array.isArray(list) ? list : [];
  } catch (error) {
    return [];
  }
}

// Busca a lista na API uma vez por entrada no app e atualiza o localStorage.
// Nas trocas de página seguintes, devolve a mesma consulta já resolvida.
export function loadPages() {
  if (!request) {
    request = api
      .get("pages")
      .then((response) => {
        const list =
          response.data.status == "success" && Array.isArray(response.data.list)
            ? response.data.list
            : [];
        try {
          localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
        } catch (error) {
          // localStorage indisponível: segue só com a lista em memória
        }
        return list;
      })
      .catch(() => {
        // Falha na API: libera nova tentativa e mantém o que já estava salvo
        request = null;
        return getCachedPages();
      });
  }
  return request;
}
